import { FC } from "react";

interface IconProps {
  color?: string;
}

const ActivityFilled: FC<IconProps> = ({ color = "#74B0D7" }) => (
  <svg viewBox="0 0 22 22" fill={color} xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.748 4.042a2.21 2.21 0 0 1 4.418 0 2.21 2.21 0 0 1-4.418 0Zm-3.53 9.487 2.65-3.418-.037.018a.687.687 0 0 0 .074-.687.676.676 0 0 0-.559-.403.704.704 0 0 0-.642.284l-2.218 2.869-2.54-1.998a.724.724 0 0 0-.522-.147.71.71 0 0 0-.458.274l-2.713 3.53-.056.083a.685.685 0 0 0 .193.87.77.77 0 0 0 .421.138.65.65 0 0 0 .541-.275l2.301-2.962 2.612 1.963.083.054c.293.156.66.083.87-.193Zm1.944-10.064c-.037.23-.055.459-.055.688a3.725 3.725 0 0 0 3.722 3.73c.229 0 .449-.027.678-.064v7.397c0 3.108-1.833 4.95-4.95 4.95H6.784c-3.118 0-4.951-1.842-4.951-4.95V8.434c0-3.117 1.833-4.969 4.95-4.969h7.38Z"
      stroke="none"
    />
  </svg>
);

export default ActivityFilled;
